// ================================================================
// Lead Mobile — Einstieg für die mobile Lead-Oberfläche (MOMO-Look).
// Orgs mit leadMobileUi=true (Platform-Schalter) sehen nach dem Login
// auf Mobilgeräten diese Oberfläche statt des Company Dashboards.
// Die eigentliche UI ist eine React-Insel (LeadMobileView) — hier nur
// Geräte-Erkennung + Lazy-Mount, damit der Desktop-Bundle schlank bleibt.
// ================================================================

// Mobil = echtes Mobilgerät ODER schmaler Viewport. Desktop-Logins derselben
// Org sehen weiterhin das volle Dashboard.
export function isMobileDevice() {
  return (
    /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent) ||
    window.matchMedia('(max-width: 820px)').matches
  );
}

export function showLeadMobile(root) {
  root.innerHTML = '<div id="lead-mobile-root"></div>';
  const el = document.getElementById('lead-mobile-root');
  Promise.all([
    import('../../react/lib/mountReact.tsx'),
    import('../../react/components/leads/LeadMobileView.tsx'),
  ]).then(([{ mountReact }, { default: LeadMobileView }]) => {
    mountReact(el, LeadMobileView, {});
  });
}
